const productDetailLogoImages = document.querySelectorAll(
	'.product--detail-logo-image',
);
const productDetailLogoPlaceholders = document.querySelectorAll(
	'.product--detail-logo-placeholder',
);

let max = 0;
productDetailLogoImages.forEach((image) => {
	const { height } = image.getBoundingClientRect();
	max = height > max ? height : max;
});
productDetailLogoPlaceholders.forEach((placeholder) => {
	placeholder.style.height = `${max}px`;
});
productDetailLogoImages.forEach((image) => {
	const partentDiv = image.closest('div');
	partentDiv.style.height = `${max}px`;
});
